import React from "react";
import { t } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import useViewController from "./viewController";
import PracticeAreaItem from "../../pages/PageLanding/components/PracticeAreaItem";
import PracticeAreaTags from "../../pages/PageLanding/components/PracticeAreaTags";
import "./style.scss";

interface Props {
  prepend?: React.ReactNode;
  append?: React.ReactNode;
}

export default function BlockPracticeAreas({ append, prepend }: Props) {
  const { categories, isActiveIndex, onClickPracticeArea } = useViewController();

  if (prepend === undefined) {
    prepend = (
      <>
        <h2 className="block-practice-areas__title h2 mb-4 text-center">
          {t("Wherever your aim, our coaches have lived it")}
        </h2>
        <div className="block-practice-areas__description subtitle-1 text-center text-neutral-darken-1 mb-10">
          {t(
            "With coaches who’ve lived the industry and a proven, outcome-led approach, we equip students with the confidence and clarity to secure the job offers they deserve, while giving universities the employability results they need."
          )}
        </div>
      </>
    );
  }

  if (append === undefined) {
    append = (
      <BaseButton
        className="block-practice-areas__btn body-big fw-bold pl-4 pr-3 mt-10"
        to={"/services"}
        large
        gradient
      >
        {t("Learn More")}
        <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
      </BaseButton>
    );
  }

  return (
    <div className="block-practice-areas d-flex __align-center __column">
      {prepend}
      <div className="block-practice-areas__content-wrapper">
        <div className="block-practice-areas__container d-flex __column gap-3 f-shrink-0">
          {categories.map((category, index) => (
            <PracticeAreaItem
              key={category.id}
              className="block-practice-areas__category-item"
              category={category}
              isActive={isActiveIndex === index}
              onClickActivator={() => onClickPracticeArea(index)}
            />
          ))}
        </div>
        {categories.length && isActiveIndex !== undefined && (
          <div className="block-practice-areas__category-container f-grow pa-6">
            <h3 className="fw-bold mb-4">{categories[isActiveIndex].title}</h3>
            <div className="block-practice-areas__category-description body-big fw-normal mb-6">
              {categories[isActiveIndex].description}
            </div>
            <PracticeAreaTags tags={categories[isActiveIndex].tags} />
          </div>
        )}
      </div>
      {append}
    </div>
  );
}
